'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Instance = undefined;

var _BaseAction2 = require('./BaseAction');

var _BaseAction3 = _interopRequireDefault(_BaseAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Class representing a update action.
 * @extends BaseAction
 */
var Instance = exports.Instance = function (_BaseAction) {
  _inherits(Instance, _BaseAction);

  /**
   * Create an instance of the update action.
   * @param {Object} config - The configuration for the action.
   */
  function Instance(config) {
    _classCallCheck(this, Instance);

    var _this = _possibleConstructorReturn(this, (Instance.__proto__ || Object.getPrototypeOf(Instance)).call(this, 'instance', config));

    _this.do = function (instance) {

      // Validate instance key
      _this.validateInstance(instance);

      return function (dispatch) {

        // Create data object to be dispatched with action
        var data = { instance: instance

          // Call BaseAction.start with dispatch and the action data
        };_this.start(dispatch, data);
      };
    };

    return _this;
  }

  /**
   * Generate an action creator with the provided data.
   * @param {Object} instance - key of instance to be created.
   *
   * @returns {Function} - Returns the instance action thunk.
   */


  return Instance;
}(_BaseAction3.default);